import React from "react";
import ConfirmDialog from "../common/ConfirmDialog";

/**
 * Specialized delete confirmation for activities
 */
const ConfirmDeleteModal = ({ isOpen, onClose, onConfirm, activityTitle }) => {
  return (
    <ConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Delete Activity"
      message={`Are you sure you want to delete "${activityTitle}"? This action cannot be undone.`}
      confirmLabel="Delete Activity"
      cancelLabel="Cancel"
      type="danger"
    />
  );
};

export default ConfirmDeleteModal;


